<template>
  <div>
    <Dash-reach-body v-if="loadingStatus.data" />
    <scroll-loader
      class="dash-loader"
      :loader-method="()=> {}"
      :loader-enable="!loadingStatus.data"
    ></scroll-loader>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import DashReachBody from "./Dash-reach-body";

export default {
  name: "Dash-reach",
  computed: {
    ...mapGetters(["getSelectedPages", "loadingStatus", "getAnalizedPages"])
  },
  components: {
    DashReachBody
  }
};
</script>

<style>
</style>